var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import ContainerPainel from '../../../components/container_painel';
import { useAuth } from '../../../contexts/auth/AuthContext';
var SemPermissao = function () {
    var DEV = useAuth().DEV;
    useEffect(function () {
        DEV && printarVariaveisAmbiente();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var printarVariaveisAmbiente = function () {
        console.log('process.env.PORTAL_URL', process.env.PORTAL_URL);
        console.log('process.env', process.env);
        console.log('process.env', JSON.stringify(process.env));
    };
    return (_jsx(ContainerPainel, { children: _jsx(Box, __assign({ justifyContent: 'center', display: 'flex', p: 1, sx: { backgroundColor: grey[50] } }, { children: _jsx(Typography, __assign({ variant: 'h5', component: 'h2', gutterBottom: true }, { children: "Voc\u00EA n\u00E3o possui permiss\u00E3o para acessar esta funcionalidade." })) })) }));
};
export default SemPermissao;
